export const DEFAULT_PANEL_WIDTH = 560;
export const MIN_PANEL_WIDTH = 380;

export function getMaxPanelWidth() {
  if (typeof window === 'undefined') return 1000;
  return Math.min(window.innerWidth - 80, 1000);
}

export function getWidePanelWidth() {
  return Math.min(getMaxPanelWidth(), 960);
}
